<template>
  <div class="questionBankDetails">
    <!--庆祝特效-->
    <div v-if="showeffect" class="celebration">
      <img :src="effect_imgurl" alt="Celebration Image" class="celebration-effect" />
    </div>
    <div class="topTitle clearfix">
      <div class="fl" v-if="$route.query.type1 === 'game1'">
        <el-page-header @back="goback1" :content="detailsFrom.code + '\xa0' + detailsFrom.title">
        </el-page-header>
      </div>
    </div>
    <div class=" main">
      <el-row>
        <el-col :span="num">
          <div class="main-left">
            <div class="main_top">
              <ul class="clearfix">
                <li style="width: calc(100% - 30px);">
                  <div style="overflow: hidden;">
                    <div class="fl">
                      <svg style="margin-top:6px;" t="1700554092168" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="14308" width="24" height="24">
                        <path d="M876.9 371.9c-39.3-91.2-112.2-163.8-203.5-202.8 25.5-20.1 57.1-31 89.6-31 80.1 0 145 64.7 145 144.6 0 33.6-11.7 64.6-31.1 89.2zM149.8 376.9C129.2 351 118 318.8 118 285.7c0-81.6 66.3-147.7 148.1-147.7 34.6 0 66.3 11.9 91.5 31.7-93.3 39.9-167.7 114-207.8 207.2z" fill="green" p-id="14309"></path>
                        <path d="M773.2 776.4c60.5-63.9 97.8-149.8 97.8-244.6C871 334.7 710.7 175 513 175S155 334.7 155 531.8c0 94.6 37.2 180.4 97.5 244.3l-49.7 49.5c-6.7 6.7-10.8 15.9-10.8 26.1 0 20.4 16.6 36.9 37 36.9 9.8 0 19.2-3.9 26.2-10.8l53.4-53.2c57.9 40.3 128.3 64.1 204.3 64.1 73.2 0.1 144.6-22.4 204.6-64.3l53.8 53.6c6.6 6.6 15.8 10.7 25.9 10.7 20.2 0 36.6-16.3 36.6-36.5 0-10.1-4.1-19.2-10.7-25.8l-49.9-50z m-58.7-203c0 18.1-14.7 32.8-32.8 32.8H499.3c-18.1 0-32.8-14.7-32.8-32.8V390.9c0-18.1 14.7-32.8 32.8-32.8 18.1 0 32.8 14.7 32.8 32.8v149.7h149.7c18.1 0 32.7 14.7 32.7 32.8z" fill="green" p-id="14310"></path>
                      </svg>
                    </div>
                    <div class="fl">
                      <div v-if="isShowTime">
                        <span style="line-height: 36px;margin-left: 10px;font-size:16px;"><span style="font-weight: bold;">距结束:</span><span style="margin-left: 10px;">{{ day }}</span>
                          <span style="margin-left: 3px;font-weight: bold;">天</span>
                          <span style="margin-left: 3px;">{{ hours }}</span>
                          <span style="margin-left: 3px;font-weight: bold;">小时</span>
                        </span>
                        <span style="margin-left: 3px;font-size: 16px;">{{
                          minutes
                        }}</span>
                        <span style="margin-left: 3px;font-size: 16px;font-weight: bold;">分</span>
                        <span style="margin-left: 3px;font-size: 16px;">{{
                          seconds
                        }}</span>
                        <span style="margin-left: 3px;font-size: 16px;font-weight: bold;">秒</span>
                      </div>
                      <div v-else style="line-height: 36px;margin-left: 5px;">
                        比赛已结束
                      </div>
                    </div>
                  </div>
                </li>

                <li @click="handleFullScreen" style="cursor: pointer;width: 20px;margin-top: 10px;">
                  <div class="txt2 el-icon-full-screen"></div>
                </li>
              </ul>
            </div>
            <div class="main_cotton" v-if="detailsFrom.description_show_type === 1">
              <div>
                <div class="txt4">描述</div>

                <div style="font-size: 12pt;" v-html="detailsFrom.description"></div>
              </div>
              <div>
                <div class="txt4">输入描述</div>

                <div style="font-size: 12pt;" v-html="detailsFrom.input_description"></div>
              </div>
              <div>
                <div class="txt4">输出描述</div>
                <div style="font-size: 12pt;" v-html="detailsFrom.output_description"></div>
              </div>

              <div class="txt4">输入输出样例</div>

              <div v-for="(sample, index) in samples" :key="index">
                <div class="flex-container sample clearfix">
                  <span class="sample-input fl">
                    <span class="title">输入样例 {{ index + 1 }}</span>
                    <span class="title" style="margin-left: 15px;cursor: pointer;"><el-tag class="tags1" :data-clipboard-text="sample.input" @click="copy" size="mini">复制</el-tag></span>
                    <pre class="language-c" v-if="language == 0"><code>{{ sample.input }}</code></pre>
                    <pre class="language-cpp" v-if="language == 1"><code>{{ sample.input }}</code></pre>
                    <pre class="language-python" v-if="language == 2"><code>{{ sample.input }}</code></pre>
                  </span>
                  <span class="sample-input fl">
                    <span class="title">输出样例 {{ index + 1 }}</span>
                    <span class="title" style="margin-left: 15px;cursor: pointer;">
                      <el-tag class="tags2" :data-clipboard-text="sample.output" @click="copy1" size="mini">复制</el-tag>
                    </span>
                    <pre class="language-c" v-if="language == 0"><code>{{ sample.output }}</code></pre>
                    <pre class="language-cpp" v-if="language == 1"><code>{{ sample.output }}</code></pre>
                    <pre class="language-python" v-if="language == 2"><code>{{ sample.output }}</code></pre>
                  </span>
                </div>
              </div>

              <div>
                <div class="txt4" v-if="detailsFrom.hint">提示</div>

                <div style="font-size: 12pt;" v-html="detailsFrom.hint"></div>
              </div>
              <div>
                <div v-if="
                    detailsFrom.attachment_url === null ||
                      detailsFrom.attachment_url === ''
                  "></div>
                <div v-else>
                  <div class="txt4">附件下载</div>
                  <div style="margin-top: 20px;">
                    <el-link @click="DownloadFile">{{ zipTxt }}</el-link>
                  </div>
                </div>
              </div>
            </div>
            <div class="main_cotton" v-if="detailsFrom.description_show_type === 2">
              <div>
                <div class="txt4">描述</div>
                <mavon-editor :style="{ 'min-height': height }" preview-background="#fff" v-model="detailsFrom.md_description" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
              </div>
              <div>
                <div class="txt4">输入描述</div>
                <mavon-editor :style="{ 'min-height': height }" preview-background="#fff" v-model="detailsFrom.md_input_description" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
              </div>
              <div>
                <div class="txt4">输出描述</div>
                <mavon-editor :style="{ 'min-height': height }" preview-background="#fff" v-model="detailsFrom.md_output_description" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
              </div>

              <div class="txt4">输入输出样例</div>

              <div v-for="(sample, index) in samples" :key="index">
                <div class="flex-container sample clearfix">
                  <span class="sample-input fl">
                    <span class="title">输入样例 {{ index + 1 }}</span>
                    <span class="title" style="margin-left: 15px;cursor: pointer;"><el-tag class="tags1" :data-clipboard-text="sample.input" @click="copy" size="mini">复制</el-tag></span>

                    <!-- <p class="title">输入样例1</p> -->

                    <pre class="language-c" v-if="language == 0"><code>{{ sample.input }}</code></pre>
                    <pre class="language-cpp" v-if="language == 1"><code>{{ sample.input }}</code></pre>
                    <pre class="language-python" v-if="language == 2"><code>{{ sample.input }}</code></pre>
                  </span>
                  <span class="sample-input fl">
                    <span class="title">输出样例 {{ index + 1 }}</span>
                    <span class="title" style="margin-left: 15px;cursor: pointer;">
                      <el-tag class="tags2" :data-clipboard-text="sample.output" @click="copy1" size="mini">复制</el-tag>
                    </span>

                    <pre class="language-c" v-if="language == 0"><code>{{ sample.output }}</code></pre>
                    <pre class="language-cpp" v-if="language == 1"><code>{{ sample.output }}</code></pre>
                    <pre class="language-python" v-if="language == 2"><code>{{ sample.output }}</code></pre>
                  </span>
                </div>
              </div>
              <div class="txt4">提示</div>
              <mavon-editor :style="{ 'min-height': height }" style="background-color: #fff;" preview-background="#fff" v-model="detailsFrom.md_hint" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
              <div v-if="
                  detailsFrom.attachment_url === null ||
                    detailsFrom.attachment_url === ''
                "></div>
              <div v-else>
                <div class="txt4">附件下载</div>
                <div style="margin-top: 20px;">
                  <el-link @click="DownloadFile">{{ zipTxt }}</el-link>
                </div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="num2">
          <div class="main-right">
            <CodeMirror class="editor" :style="{ height: scrollerHeight }" :code="code" :arr1="arr1" :language="language" @cdata="oncdata" @changeLang="onChangeLang" @handleFullScreen1="handleFullScreen1"></CodeMirror>

            <div class="Console" v-if="isshow2">
              <el-tabs type="border-card" v-model="activeName1">
                <el-tab-pane label="测试用例" name="first1">
                  <el-input type="textarea" resize="none" v-model="desc" :autosize="{ minRows: 5, maxRows: 5 }"></el-input>
                </el-tab-pane>
                <el-tab-pane label="代码执行结果" name="second1">
                  执行结果:
                  <div v-if="result1 === 0">
                    <div style="margin-top:10px">
                      <el-alert style="white-space:pre" v-html="output" type="success">
                      </el-alert>
                    </div>
                  </div>
                  <span v-if="result1 === -1">程序输出不正确</span>
                  <span style="color: #8F2624;" v-if="result1 === 1">时间超限</span>
                  <span style="color: #8F2624;" v-if="result1 === 2">时间超限</span>
                  <span style="color: #8F2624;" v-if="result1 === 3">内存超限</span>
                  <span style="color: #8F2624;" v-if="result1 === 4">程序运行错误</span>
                  <span style="color: #8F2624;" v-if="result1 === 5">系统错误</span>
                  <!-- <span style="color: #8F2624;" v-if="result1 === 5">系统错误</span> -->
                  <span style="color: #8F2624;" v-if="result1 === -2">编译失败</span>
                  <span style="color: #8F2624;" v-if="result1 === 6">等待测评</span>
                  <span style="color: #8F2624;" v-if="result1 === 7">测评中</span>
                  <span v-if="result1 === 8">部分输出正确</span>
                  <div v-if="result1 === -2 ? true : false" style="margin-top:10px" class="weeor">
                    <div style="border:1px solid #F2F6FC;padding:10px;border-radius:10px;margin-bottom:5px;color:red;" v-for="item in errorlist" :key="item.index">
                      <span style="margin-bottom:10px;">{{ item }}</span>
                      <br />
                    </div>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
            <div :style="{ margin: marginTop }">
              <div class="clearfix" style="position: relative; z-index: 10;">
                <div class="fl">
                  <!-- <el-button v-if="$route.query.type1 === 'game1' ? true : false" size="small" type="primary"
                    @click="submit" :disabled="disabled1" :loading="disabled2">提交代码</el-button> -->

                  <el-button type="text" style="color:#606266;margin-right:10px" size="small" @click="Console" :disabled="disabled1">控制台
                    <span v-if="isshow2 === false" class="el-icon-caret-bottom"></span>
                    <span v-else class="el-icon-caret-top"></span>
                  </el-button>
                  <el-dropdown trigger="click" v-if="isshow2" class="select">
                    <span class="el-dropdown-link" ref="ellink">
                      <span style="font-size:12px; cursor: pointer;color:#0A84FF">填入示例<i class="el-icon-arrow-down el-icon--right" /></span>
                    </span>
                    <el-dropdown-menu slot="dropdown" align="center">
                      <el-dropdown-item v-for="(item, index) in samples" :key="index" style="padding:0 10px 0 10px;text-align: left;" @click.native="ChangeSamples(item.input)">
                        样例{{ index + 1 }}
                        <span style="margin-left:10px;color:#ccc">{{
                          item.input
                        }}</span>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
                <div v-if="$route.query.type1 === 'game1' ? true : false">
                  <div class="fl main_msg" style="margin-left:20px;margin-top:4px;" v-if="
                      $route.query.rule_type != 2 && !disabled1 && code !== ''
                    ">
                    <el-tag size="mini" v-if="result === -1" type="warning">程序输出不正确</el-tag>
                    <el-tag size="mini" v-if="result === 0" effect="dark" type="success">恭喜你通过了这道题!</el-tag>
                    <el-tag size="mini" v-if="result === 1" type="warning">时间超限</el-tag>
                    <el-tag size="mini" v-if="result === 2" type="warning">时间超限</el-tag>
                    <el-tag size="mini" v-if="result === 3" type="warning">内存超限</el-tag>
                    <el-tag size="mini" v-if="result === 4" type="warning">程序运行错误</el-tag>
                    <el-tag size="mini" v-if="result === 5" type="warning">系统错误</el-tag>
                    <el-tag size="mini" v-if="result === -2" type="warning">编译失败</el-tag>
                    <el-tag size="mini" v-if="result === 6" type="warning">等待测评</el-tag>
                    <el-tag size="mini" v-if="result === 7" type="warning">测评中</el-tag>
                    <el-tag size="mini" v-if="result === 8" type="success">部分输出正确</el-tag>
                  </div>
                </div>
                <div v-if="
                    $route.query.rule_type === 2 && !disabled1 && code !== ''
                  " class="fl main_msg" style="margin-left:20px;margin-top:4px;">
                  <el-tag size="mini" v-if="result != null" effect="dark" type="success">提交成功!</el-tag>
                </div>
                <div class="fl" v-if="isshow1">
                  <div style="margin-top:4px;margin-left:10px;">
                    <el-tag v-if="$route.query.rule_type === 3 ? true : false" size="mini">提交次数:{{
                        ioiUserCoutestProblemSubmissionCount
                      }}次</el-tag>
                  </div>
                </div>
                <div class="fr">
                  <el-button-group style="margin-right:20px">
                    <!-- <el-button size="small" type="" @click="redo" :disabled="disabled1">重做</el-button> -->
                    <!-- <el-button size="small" type="" style="margin-left:0px" :disabled="disabled1"
                      @click="GoSubmitRecords">记录</el-button> -->
                  </el-button-group>
                  <el-button-group>
                    <el-button size="small" type="" @click="test" :disabled="disabled1" :loading="disabled3">测试</el-button>
                    <el-button size="small" type="primary" @click="submit" :disabled="disabled1" :loading="disabled2">提交代码</el-button>
                  </el-button-group>
                </div>
              </div>
            </div>

            <el-dialog title="编译信息" :visible.sync="dialogVisible" width="40%" :destroy-on-close="true">
              <div style="max-height:50vh;overflow-y:scroll;">
                <div style="border:1px solid #F2F6FC;padding:10px;border-radius:10px;margin-bottom:5px;color:red;" v-for="item in errorlist" :key="item.index">
                  <span style="margin-bottom:10px;">{{
                    "【错误】" + item
                  }}</span>
                </div>
              </div>
            </el-dialog>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-drawer :with-header="false" :visible.sync="drawer" direction="rtl" size="86%">
      <div class="clearfix">
        <div class="fl" style="width:calc(50% - 10px)">
          <div style="padding:20px;padding-right: 10px;">
            <el-table ref="subMitList" highlight-current-row size="mini" :data="tableData" stripe style="width: 100%" :header-cell-style="{ background: 'white', color: '#909399' }" @cell-click="lookDetil">
              <el-table-column type="index" label="序号">
                <template slot-scope="scope">
                  <span>{{
                    scope.$index + 1 + (page_no - 1) * page_size
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="语言">
                <template slot-scope="scope">
                  <span v-if="scope.row.language === 0">C</span>
                  <span v-if="scope.row.language === 1">C++</span>
                  <span v-if="scope.row.language === 2">Python3</span>
                </template>
              </el-table-column>
              <el-table-column label="耗时">
                <template slot-scope="scope">
                  <span>{{ scope.row.time_cost }}ms</span>
                </template>
              </el-table-column>
              <el-table-column label="内存">
                <template slot-scope="scope">
                  <span>{{ scope.row.memory_cost / 1024 }}kb</span>
                </template>
              </el-table-column>

              <el-table-column prop="created_time" label="提交时间" width="200">
              </el-table-column>
              <el-table-column label="状态" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span v-if="scope.row.result === -1">程序输出不正确</span>
                  <span v-if="scope.row.result === 0">程序输出正确</span>
                  <span v-if="scope.row.result === 1">超时</span>
                  <span v-if="scope.row.result === 2">超时</span>
                  <span v-if="scope.row.result === 3">内存超限</span>
                  <span v-if="scope.row.result === 4">程序运行错误</span>
                  <span v-if="scope.row.result === 5">系统错误</span>
                  <span v-if="scope.row.result === -2">编译失败</span>
                  <span v-if="scope.row.result === 6">等待测评</span>
                  <span v-if="scope.row.result === 7">测评中</span>
                  <span v-if="scope.row.result === 8">部分输出正确</span>
                </template>
              </el-table-column>
              <el-table-column prop="score" label="得分" fixed="right">
                <template slot-scope="scope">
                  <span v-if="scope.row.result === 6">--</span>
                  <span v-else @click.stop="detailsScope(scope.row)" style="cursor: pointer; color:blue">{{ scope.row.score }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div style="margin: 20px; text-align: right">
            <el-pagination @current-change="handleCurrent" :current-page="page_no" :page-size="page_size" :total="total">
            </el-pagination>
          </div>
        </div>
        <div class="fr codeStyle" style="width:calc(50% - 12px);border-left: 2px solid #f2f6fc; min-height: 100vh; padding-left: 10px;padding-right: 10px;">
          <div style="margin-top: 12px;overflow-y: auto;border-radius:5px;">
            <code-mirror1 v-model="code1" style="height: 100vh;font-size: 16px;"></code-mirror1>
          </div>
        </div>
      </div>
    </el-drawer>

    <el-dialog title="测试点信息" :visible.sync="dialogVisible2" width="80%">
      <div style="margin-top:20px">
        <ul style="overflow: hidden;">
          <li v-for="(item, index) in textInfo2" :key="index" class="fl liListStyle" style="width:calc(50% - 10px); margin-bottom: 10px;">
            <div class="box1 clearfix">
              <div class="fl" style="margin-right:20px">
                {{ "#" + (index + 1 + "") }}
              </div>
              <div class="fl">{{ item.real_time }}ms /</div>
              <div class="fl">{{ item.memory / 1024 }}kb /</div>
              <div class="fl">{{ item.cpu_time }}ms</div>

              <div class="fr">
                <div v-if="item.result === 0" class="el-icon-success" style="color: #67C23A; font-size: 14px;"></div>
                <div v-else class="el-icon-error" style="color: #F56C6C; font-size: 14px;"></div>
              </div>
              <div class="fr" style="margin-right:10px">{{ item.score }}分</div>
              <div class="fr" style="margin-right:10px;color: #409EFF; cursor: pointer;" @click="downloadFilesAndCreateZip(item, index)" v-if="item.result != 0 && ($store.state.user.identity === 2?$store.state.user.userInfo.ojTestcaseAuth:true)">
                下载
              </div>
              <div class="fr" style="margin-right:10px;color: #409EFF; cursor: pointer;" @click="look(item, index)" v-if="item.result != 0 && ($store.state.user.identity === 2?$store.state.user.userInfo.ojTestcaseAuth:true)">
                查看
              </div>
            </div>
          </li>
        </ul>
      </div>
    </el-dialog>
    <el-dialog title="测试点信息" :visible.sync="dialogVisible3" width="80%" @close="closeDialog">
      <div style="height: calc(50vh - 10px); padding-bottom: 10px; ">
        <span style="font-weight: bold;">{{ "#" + indexcode }} 测试用例</span>
        <div style="margin-top:10px;height: 100%; overflow: hidden;">
          <div class="fl" style="width: calc(50% - 20.5px);height: 100%; padding-left:10px;padding-right: 10px;overflow-x:auto; overflow-y: auto;">
            <div style="font-weight: 600;">输入用例:</div>
            <div style="main_top:10px">
              <span style="white-space:pre">{{ inTXt }}</span>
            </div>
          </div>
          <div class="fl" style="width: 1px; background: #ccc;overflow-x: auto;height: 100%"></div>
          <div class="fl" style="width: calc(50% - 20.5px);height: 100%;padding-left:10px;padding-right: 10px;overflow-x: auto;overflow-y: auto;">
            <div style="font-weight: 600;">输出用例:</div>
            <div style="main_top:10px">
              <span style="white-space:pre">{{ outTxt }}</span>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <!--ChatGPT-->
    <el-drawer title="Ai助手 - P仔" :visible.sync="drawer1" :with-header="false" size="50%">
      <iframe style="width: 100%; height: 100vh;overflow:hidden;" src="/chatgpt/index.html"></iframe>
    </el-drawer>
  </div>
</template>

<script>
import CodeMirror from "@/pages/OJ/components/CodeMirrorGame";

// import CodeMirror1 from "@/components/CodeMirror";
import moment from "moment";

import {
  getOjProblemInfoById,
  createSubmission,
  getOjSubmissionInfo,
  getUserOjSubmissionList,
  createRunRecord,
  getOjRunRecordInfo,
  getTestcaseDownloadNum,
  getTestcaseViewNum
} from "@/api/educational.js";
import Clipboard from "clipboard";
import Prism from "prismjs";

// 在Vue组件中引入markdown-it
import MarkdownIt from "markdown-it";
import hljs from "highlight.js";
import "highlight.js/styles/base16/monokai.css";
import cpp from "highlight.js/lib/languages/cpp";
import axios from "axios";
import OSS from "ali-oss";
import JSZip from "jszip";
import FileSaver from "file-saver";
hljs.registerLanguage("cpp", cpp);

// 使用markdown-it
let md = new MarkdownIt({
  highlight: function (str, lang) {
    if (lang && hljs.getLanguage(lang)) {
      try {
        return (
          '<pre class="hljs"><code>' +
          hljs.highlight(lang, str, true).value +
          "</code></pre>"
        );
      } catch (error) {
        console.log(error);
      }
    }
    return (
      '<pre class="hljs"><code>' + md.utils.escapeHtml(str) + "</code></pre>"
    );
  },
});

export default {
  components: {
    CodeMirror,
    // CodeMirror1
  },
  data() {
    return {
      code1: "",
      dialogVisible3: false,
      zipTxt: "",
      height: "0px",
      error_info: "",
      result1: null,
      activeName1: "first1",
      output: "",
      intervalcounter1: 0,
      runRecordId: "",

      SamplesTxt: null,
      scrollerHeight: "calc(100vh - 230px) !important",
      marginTop: "25px 20px 16px 20px",
      isshow2: false,
      desc: "",
      dialogVisible1: false,

      textInfo: [],
      textInfo1: [],

      textInfo2: [],

      dialogVisible2: false,
      page_no: 1,
      page_size: 20,
      total: 20,
      tableData5: [],
      drawer: false,
      intervalcounter: 0,
      isshow1: false,
      ioiUserCoutestProblemSubmissionCount: "",
      errrorInfo: "",
      tableData: [],
      result: null,
      msg: "",
      clearTimeSet: null,
      disabled1: false,
      disabled2: false,
      disabled3: false,

      problem_id: "",
      samples: [],
      detailsFrom: {},
      num: 8,
      num2: 16,
      languagesList: [],
      arr1: [],
      languages1: [
        {
          id: "0",
          label: "c",
        },
        {
          id: "1",
          label: "c++",
        },
        {
          id: "2",
          label: "Python3",
        },
      ],

      code: "",
      language: "0",
      submissionId: 0,
      dialogVisible: false,

      //AI题解
      drawer1: false,
      api_key: "",

      //chatgpt配置
      loading: false,
      streamCache: "",
      messages: [],
      error_message: "",
      errorlist: [], //问题列表
      test_case_id: "",
      inTXt: "",
      outTxt: "",
      indexcode: "",
      countdownTime: "",
      timer: null,
      day: "",
      hours: "",
      minutes: "",
      seconds: "",
      isShowTime: false,

      //庆祝特效
      showeffect: false,
      effect_imgurl: "",
    };
  },
  watch: {
    code(newVal, oldVal) {
      console.log(newVal, 222344);
      console.log(oldVal, 222344);
    },
  },
  created() {
    this.problem_id = this.$route.query.id;

    console.log(this.$route.query.txt, 787845);

    if (this.$route.query.type1 === "game1") {
      console.log(this.$route.query.languages, 1122455);
      this.languagesList = JSON.parse(this.$route.query.languages);
      this.languagesList.sort();
      console.log(this.languages1, 123456789);

      if (this.$route.query.txt === undefined) {
        if (this.languagesList.includes("1")) {
          this.language = "1";
        } else {
          this.language = this.languagesList[0];
        }
      } else {
        this.language = this.$route.query.language;
      }

      this.languagesList.map((item) => {
        console.log(item, 12346);
        let obj = this.languages1.find(function (e) {
          return e.id === item;
        });
        console.log(obj, 1474411);
        this.arr1.push(obj);
      });
      console.log(this.arr1, 1474411);
      console.log(this.languagesList, 123456798);
    }
  },
  mounted() {
    console.log(this.$route.query, 6669);

    console.log(this.$route.query.type, 5632323);
    console.log(this.$route.query.problemlist_id, 586532);

    console.log(this.$store.state.user.identity, 11232345);
    // Prism.highlightAll();
    this.getUserOjSubmissionList();
    this.getOjProblemInfoById();
    console.log(sessionStorage.getItem("codeTxt"), 123456);

    if (
      sessionStorage.getItem("codeTxt") === "" ||
      sessionStorage.getItem("codeTxt") === null
    ) {
      this.code = "";
    } else {
      this.code = sessionStorage.getItem("codeTxt");
    }
    this.countDown();
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
    countDown() {
      let endTime = new Date(this.$route.query.end_date.replace(/-/g, '/')) // 结束时间
      this.timer = setInterval(() => {
        let nowTime = moment()
          .locale("zh-cn")
          .format("YYYY-MM-DD HH:mm:ss"); //当前时间
        let endTime1 = moment(endTime)
          .locale("zh-cn")
          .format("YYYY-MM-DD HH:mm:ss");
        console.log(endTime1);
        let x = moment(endTime).diff(moment(nowTime), "seconds");
        var d = moment.duration(x, "seconds");
        console.log(x, 12545);

        console.log(d, 12545);

        this.countdownTime =
          Math.floor(d.asDays()) +
          "天" +
          d.hours() +
          "时" +
          d.minutes() +
          "分" +
          d.seconds() +
          "秒";
        this.day = Math.floor(d.asDays());
        this.hours = d.hours();
        this.minutes = d.minutes();
        this.seconds = d.seconds();
        console.log(Number.isNaN(x), 4578);

        if (x < 0) {
          clearInterval(this.timer);
          this.timer = null;
          this.isShowTime = false;
          console.log(1111);
        } else {
          this.isShowTime = true;
          console.log(212222);
        }
        if (Number.isNaN(x) == true) {
          clearInterval(this.timer);
          this.timer = null;
          this.isShowTime = false;
        }
      }, 1000);
    },
    lookDetil(val) {
      console.log(val, 12465);
      this.code1 = val.code;
    },
    look(val, index) {
      getTestcaseViewNum().then((res) => {
        if (res.test_case_view_num == -1) {
          this.$message.warning("今日查看次数已用完");
          this.dialogVisible3 = false;
        } else {
          console.log(this.$store.state.user.token, 123465);
          this.inTXt = "";
          this.outTxt = "";
          this.indexcode = index + 1;

          let client;
          let client1;

          axios
            .get("/api/get/aliyun/sts", {
              headers: {
                Authorization: this.$store.state.user.token,
                "X-Requested-With": "XMLHttpRequest",
              },
            })
            .then((res) => {
              client = new OSS({
                region: "oss-cn-zhangjiakou",
                accessKeyId: res.data.AccessKeyId,
                accessKeySecret: res.data.AccessKeySecret,
                stsToken: res.data.SecurityToken,
                bucket: "wugetestcase",
                secure: true,
              });
              client1 = new OSS({
                region: "oss-cn-zhangjiakou",
                accessKeyId: res.data.AccessKeyId,
                accessKeySecret: res.data.AccessKeySecret,
                stsToken: res.data.SecurityToken,
                bucket: "wugetestcase",
                secure: true,
              });
              let url = "problem/" + this.test_case_id + "/" + val.input_name;
              let url1 = "problem/" + this.test_case_id + "/" + val.output_name;
              url = client.signatureUrl(url);
              url1 = client1.signatureUrl(url1);
              console.log(url);
              console.log(url1);

              const xhr = new XMLHttpRequest();
              const xhr1 = new XMLHttpRequest();

              xhr.open("GET", url, true);
              xhr.onreadystatechange = () => {
                this.inTXt = xhr.responseText;
              };
              xhr.send();
              xhr1.open("GET", url1, true);
              xhr1.onreadystatechange = () => {
                this.outTxt = xhr1.responseText;
              };
              xhr1.send();
            });

          this.$message.success("剩余查看次数" + res.test_case_view_num);
          this.dialogVisible3 = true;
        }
      });
    },
    downloadFilesAndCreateZip(val, index) {
      console.log(index);
      getTestcaseDownloadNum().then((res) => {
        console.log(res, 123154);
        if (res.test_case_download_num == -1) {
          this.$message.warning("今日下载次数已用完");
        }
        if (res.test_case_download_num != -1) {
          let client2;
          let client3;

          axios
            .get("/api/get/aliyun/sts", {
              headers: {
                Authorization: this.$store.state.user.token,
                "X-Requested-With": "XMLHttpRequest",
              },
            })
            .then((res) => {
              client2 = new OSS({
                region: "oss-cn-zhangjiakou",
                accessKeyId: res.data.AccessKeyId,
                accessKeySecret: res.data.AccessKeySecret,
                stsToken: res.data.SecurityToken,
                bucket: "wugetestcase",
                secure: true,
              });
              client3 = new OSS({
                region: "oss-cn-zhangjiakou",
                accessKeyId: res.data.AccessKeyId,
                accessKeySecret: res.data.AccessKeySecret,
                stsToken: res.data.SecurityToken,
                bucket: "wugetestcase",
                secure: true,
              });
              let url = "problem/" + this.test_case_id + "/" + val.input_name;
              let url1 = "problem/" + this.test_case_id + "/" + val.output_name;
              let url2 = client2.signatureUrl(url);
              let url3 = client3.signatureUrl(url1);
              console.log(url, 123456);
              console.log(url1, 123456);
              console.log(url2, 1234561);
              console.log(url3, 1234561);
              this.$nextTick(() => {
                this.xiazai(url2, url3, val.input_name, val.output_name);
              });
            });
          this.$message.success("剩余下载次数" + res.test_case_download_num);
        }
      });
    },
    async xiazai(url2, url3, input_name, output_name) {
      console.log(url2);
      console.log(url3);
      //下载压缩包
      const zip = new JSZip();
      const inResult = await axios.get(url2, {
        responseType: "arraybuffer",
      });
      zip.file(input_name, inResult.data);
      const outResult = await axios.get(url3, {
        responseType: "arraybuffer",
      });
      zip.file(output_name, outResult.data);
      zip.generateAsync({ type: "blob" }).then((content) => {
        FileSaver(content, "测试用例.zip");
      });
    },

    closeDialog() {
      this.dialogVisible3 = false;
    },

    copy() {
      console.log(12345);
      var clipboard = new Clipboard(".tags1");
      console.log(clipboard);

      clipboard.on("success", (e) => {
        console.log("复制成功");
        console.log(e);
        this.$message.success("复制成功");
        //  释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        console.log(e);
        console.log("该浏览器不支持复制");
        // 释放内存
        clipboard.destroy();
      });
    },
    copy1() {
      console.log(12345);
      var clipboard = new Clipboard(".tags2");
      console.log(clipboard);

      clipboard.on("success", (e) => {
        console.log("复制成功");
        console.log(e);
        this.$message.success("复制成功");
        //  释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        console.log(e);
        console.log("该浏览器不支持复制");
        // 释放内存
        clipboard.destroy();
      });
    },

    Console() {
      this.isshow2 = !this.isshow2;
      if (this.isshow2 === true) {
        this.scrollerHeight = "calc(100vh - 420px) !important";
        this.marginTop = "27px 20px 16px 20px";
      } else {
        this.scrollerHeight = "calc(100vh - 230px) !important";
        this.marginTop = "25px 20px 16px 20px";
      }
      this.desc = this.samples[0].input;
    },
    ChangeSamples(val) {
      console.log(val, 125);
      this.desc = val;
    },
    AddInputSample() {
      console.log(this.samples, 2223);
    },
    test() {
      this.isshow2 = true;
      if (this.isshow2 === true) {
        this.scrollerHeight = "calc(100vh - 420px) !important";
        this.marginTop = "27px 20px 16px 20px";
      } else {
        this.scrollerHeight = "calc(100vh - 230px) !important";
        this.marginTop = "25px 20px 16px 20px";
      }
      if (this.code === "") {
        this.$message.warning("代码不能为空");
        return false;
      }
      createRunRecord({
        problem_id: this.problem_id,
        code: this.code,
        language: this.language,
        input: this.desc,
      }).then((res) => {
        this.runRecordId = res.data.runRecordId;
        console.log(this.runRecordId, 22354);
        this.$nextTick(() => {
          this.getOjRunRecordInfo();
        });
      });
    },
    getOjRunRecordInfo() {
      this.errorlist = [];
      getOjRunRecordInfo({
        run_record_id: this.runRecordId,
      }).then((res) => {
        clearInterval(this.clearTimeSet1);
        if (res.runRecordInfo.result === 6 || res.runRecordInfo.result === 7) {
          this.intervalcounter1++;
          this.disabled1 = true;
          this.disabled3 = true;
          console.log(this.intervalcounter1, 123456);
          this.clearTimeSet1 = setInterval(this.getOjRunRecordInfo, 1000);

          if (this.intervalcounter1 === 20) {
            clearInterval(this.clearTimeSet1);
            this.$message.warning("判题超时");
            this.disabled1 = false;
            this.disabled3 = false;
          }
          console.log(this.intervalcounter1, 123456);
        } else {
          this.disabled1 = false;
          this.disabled3 = false;

          clearInterval(this.clearTimeSet1);
          this.intervalcounter1 = 0;
          let aa = res.runRecordInfo.output.replace(/\n/g, "<br>");

          this.output = aa;
          // this.xxx.name = aa;

          this.activeName1 = "second1";
          this.result1 = res.runRecordInfo.result;
          this.error_info = res.runRecordInfo.error_info;

          const errors = res.runRecordInfo.error_info.split("cpp:");

          for (let i = 0; i < errors.length; i++) {
            console.log("错误信息");
            console.log(errors[i]);

            if (errors[i].indexOf("error") !== -1) {
              console.log("存在的错误信息");
              console.log(errors[i]);

              if (errors[i].indexOf("/judger") !== -1) {
                this.errorlist.push(errors[i].split("/judger")[0]);
              } else {
                this.errorlist.push(errors[i]);
              }
            }
          }
        }
      });
    },

    detailsScope(row) {
      console.log(row.testcases_info);
      this.textInfo = JSON.parse(row.testcases_info);
      var obj = this.textInfo1.map((item, index) => {
        return { ...item, ...this.textInfo[index] };
      });
      this.textInfo2 = obj;
      console.log(this.textInfo2, 222111);
      this.dialogVisible2 = true;
    },
    onChangeLang(newLang) {
      this.page_no = 1;
      this.language = newLang;
      console.log(this.language);

      getUserOjSubmissionList({
        language: newLang,
        problem_id: this.problem_id,
        page_no: this.page_no,
        page_size: this.page_size,
        contest_id: this.$route.query.oj_contest_id,
      }).then((res) => {
        console.log(res);
        this.tableData = res.submissionList;
        if (this.tableData.length === 0) {
          this.code = "";
        }
        if (
          sessionStorage.getItem("codeTxt") === "" ||
          sessionStorage.getItem("codeTxt") === null
        ) {
          if (this.tableData.length > 0) {
            this.code = this.tableData[0].code;
            this.language = this.tableData[0].language.toString();
            // this.tableData.map((item) => {
            //   console.log(item, 12189676)
            //   this.code = item.code
            //   this.language = item.language.toString()
            // })
          } else {
            if (this.language === "0") {
              console.log(JSON.parse(this.detailsFrom.template)[0], 111);
              if ("0" in JSON.parse(this.detailsFrom.template)) {
                this.code = JSON.parse(this.detailsFrom.template)[0].match(
                  /\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/
                )[1];
              } else {
                this.code = "";
              }
              // this.code = JSON.parse(this.detailsFrom.template)[0].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1] ? JSON.parse(this.detailsFrom.template)[0].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1] : '';
            }

            if (this.language === "1") {
              if ("1" in JSON.parse(this.detailsFrom.template)) {
                this.code = JSON.parse(this.detailsFrom.template)[1].match(
                  /\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/
                )[1];
              } else {
                this.code = "";
              }
              // this.code = JSON.parse(this.detailsFrom.template)[1].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1] ? JSON.parse(this.detailsFrom.template)[1].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1] : '';
            }
            if (this.language === "2") {
              if ("2" in JSON.parse(this.detailsFrom.template)) {
                this.code = JSON.parse(this.detailsFrom.template)[2].match(
                  /\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/
                )[1];
              } else {
                this.code = "";
              }
            }
          }
        } else {
          this.code = sessionStorage.getItem("codeTxt");
        }
      });
    },
    oncdata(val) {
      console.log(val, 123465);
      this.code = val;
      // if (sessionStorage.getItem('codeTxt') == '') {
      //   this.code = val;

      // } else {
      //   this.code = sessionStorage.getItem('codeTxt')
      // }
    },
    getUserOjSubmissionList() {
      if (this.$route.query.txt === undefined) {
        getUserOjSubmissionList({
          problem_id: this.problem_id,
          page_no: this.page_no,
          page_size: this.page_size,
          contest_id: this.$route.query.oj_contest_id,
        }).then((res) => {
          console.log(res, 852323);
          this.tableData = res.submissionList;
          if (
            sessionStorage.getItem("codeTxt") == "" ||
            sessionStorage.getItem("codeTxt") === null
          ) {
            if (this.tableData.length > 0) {
              this.code = this.tableData[0].code;
              this.language = this.tableData[0].language.toString();

              // this.language = this.tableData[0].language.toString()
              // this.tableData.map((item) => {
              //   console.log(item.code)
              //   // this.code = item.code
              //   this.language = item.language.toString()
              // })
            }
          } else {
            this.code = sessionStorage.getItem("codeTxt");
          }
        });
      } else {
        getUserOjSubmissionList({
          language: this.$route.query.language,
          problem_id: this.problem_id,
          page_no: this.page_no,
          page_size: this.page_size,
          contest_id: this.$route.query.oj_contest_id,
        }).then((res) => {
          console.log(res);
          this.tableData = res.submissionList;
          if (
            sessionStorage.getItem("codeTxt") == "" ||
            sessionStorage.getItem("codeTxt") === null
          ) {
            if (this.tableData.length > 0) {
              this.code = this.tableData[0].code;
              this.language = this.tableData[0].language.toString();
            }
          } else {
            this.code = sessionStorage.getItem("codeTxt");
          }
        });
      }
    },
    GoSubmitRecords() {
      this.page_no = 1;
      this.drawer = true;
      // getUserOjSubmissionList({
      //   problem_id: this.problem_id,
      //   page_no: this.page_no,
      //   page_size: this.page_size
      // }).then((res) => {
      //   console.log(res)
      //   this.tableData = res.submissionList
      //   this.total = res.total
      // })
      getUserOjSubmissionList({
        problem_id: this.problem_id,
        page_no: this.page_no,
        page_size: this.page_size,
        contest_id: this.$route.query.oj_contest_id,
      }).then((res) => {
        console.log(res);
        this.tableData = res.submissionList;
        if (this.tableData.length != 0) {
          console.log(this.tableData[0].code, 123456);
          this.code1 = this.tableData[0].code;
          console.log(this.code1, 123456);
          this.$nextTick(() => {
            this.$refs.subMitList.setCurrentRow(this.tableData[0]);
          });
        }
        this.total = res.total;
      });

      // const { href } = this.$router.resolve({
      //   name: 'SubmitRecords',
      //   query: {
      //     problem_id: this.problem_id
      //   }
      // });
      // window.open(href, '_blank');
    },
    handleCurrent(val) {
      this.page_no = val;
      getUserOjSubmissionList({
        problem_id: this.problem_id,
        page_no: this.page_no,
        page_size: this.page_size,
        contest_id: this.$route.query.oj_contest_id,
      }).then((res) => {
        console.log(res);
        this.tableData = res.submissionList;
        this.total = res.total;
      });
    },

    // changeLang:()

    submit() {
      let contest_id = this.$route.query.oj_contest_id;
      if (!this.code) {
        this.$message.warning("代码不能为空");

        var mp3Url = "";
        var player = null;

        mp3Url =
          "https://steamfun-cdn.oss-cn-zhangjiakou.aliyuncs.com/resources/static/mp3/wrong.mp3";
        player = new Audio(mp3Url);
        player.play(); //播放 mp3这个音频对象

        return;
      }
      if (this.isShowTime == false) {
        contest_id = "";
      }

      createSubmission({
        problem_id: this.problem_id,
        code: this.code,
        language: this.language,
        shared: 1,
        oj_contest_id: contest_id,
      }).then((res) => {
        console.log(res.data.ioiUserCoutestProblemSubmissionCount, 2222);
        this.submissionId = res.data.submissionId;
        this.ioiUserCoutestProblemSubmissionCount =
          res.data.ioiUserCoutestProblemSubmissionCount;
        this.isshow1 = true;

        // setTimeout
        // this.clearTimeSet = setInterval(this.getOjSubmissionInfo, 1000);
        this.$nextTick(() => {
          this.getOjSubmissionInfo();
        });
        // setTimeout(this.getOjSubmissionInfo, 1000)
      });
    },
    getOjSubmissionInfo() {
      this.errorlist = [];

      getOjSubmissionInfo({
        submission_id: this.submissionId,
      }).then((res) => {
        clearInterval(this.clearTimeSet);

        if (res.submission.result === 6 || res.submission.result === 7) {
          this.disabled1 = true;
          this.disabled2 = true;
          this.intervalcounter++;
          console.log(this.intervalcounter, 123456);
          this.clearTimeSet = setInterval(this.getOjSubmissionInfo, 1000);

          if (this.intervalcounter === 20) {
            clearInterval(this.clearTimeSet);
            this.$message.warning("判题超时");
            this.disabled1 = false;
            this.disabled2 = false;
          }

          console.log(this.intervalcounter, 123456);
        } else {
          clearInterval(this.clearTimeSet);

          console.log(this.intervalcounter, 123456);
          this.intervalcounter = 0;
          this.disabled1 = false;
          this.disabled2 = false;

          this.errrorInfo = res.submission.error_info;

          this.result = res.submission.result;

          const errors = res.submission.error_info.split("cpp:");

          for (let i = 0; i < errors.length; i++) {
            console.log("错误信息");
            console.log(errors[i]);

            if (errors[i].indexOf("error") !== -1) {
              console.log("存在的错误信息");
              console.log(errors[i]);

              if (errors[i].indexOf("/judger") !== -1) {
                this.errorlist.push(errors[i].split("/judger")[0]);
              } else {
                this.errorlist.push(errors[i]);
              }
            }
          }

          if (
            this.$route.query.rule_type != 2 &&
            !this.disabled1 &&
            this.code !== ""
          ) {
            /**
               * 0:恭喜你通过了这道题
               * -2:编译失败
               * -1:程序输出不正确
               * 1:时间超限
               * 2:时间超限
               * 3:内存超限
               * 4:程序运行错误
               * 5:系统错误
               * 6:等待测评
               * 7:测评中
               * 8:部分输出正确
               */
            // const errStateList = [-2, -1, 1, 2, 3, 4, 5, 6, 7, 8] // 错误
            if (this.result === 0) { // 正确
              this.effect_imgurl =
                "https://wugecdn.steam.fun/resources/static/oj/oj_success.png";
            } else {
              this.effect_imgurl =
                "https://wugecdn.steam.fun/resources/static/oj/oj_%E9%94%99%E8%AF%AF%E5%95%A6.png";
            }
            if (!this.errrorInfo) { // 如果没有错误的诊断再提示图片
              this.showeffect = true;
              setTimeout(() => {
                this.showeffect = false;
              }, 2000); // 1秒后隐藏庆祝特效
            }
          }

          if (this.errrorInfo != "" && this.$route.query.rule_type != 2) {
            this.dialogVisible = true;
          }

          var mp3Url = "";
          var player = null;
          if (this.$route.query.rule_type != 2) {
            if (this.result == 0) {
              mp3Url =
                "https://steamfun-cdn.oss-cn-zhangjiakou.aliyuncs.com/resources/static/mp3/coin.mp3";
              player = new Audio(mp3Url);
              player.play(); //播放 mp3这个音频对象
            } else {
              mp3Url =
                "https://steamfun-cdn.oss-cn-zhangjiakou.aliyuncs.com/resources/static/mp3/wrong.mp3";
              player = new Audio(mp3Url);
              player.play(); //播放 mp3这个音频对象
            }
          }
        }
      });
    },

    redo() {
      if (this.language === "0") {
        console.log(JSON.parse(this.detailsFrom.template)[0], 111);
        if ("0" in JSON.parse(this.detailsFrom.template)) {
          this.code = JSON.parse(this.detailsFrom.template)[0].match(
            /\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/
          )[1];
        } else {
          this.code = "";
        }
        // this.code = JSON.parse(this.detailsFrom.template)[0].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1] ? JSON.parse(this.detailsFrom.template)[0].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1] : '';
      }

      if (this.language === "1") {
        if ("1" in JSON.parse(this.detailsFrom.template)) {
          this.code = JSON.parse(this.detailsFrom.template)[1].match(
            /\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/
          )[1];
        } else {
          this.code = "";
        }
        // this.code = JSON.parse(this.detailsFrom.template)[1].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1] ? JSON.parse(this.detailsFrom.template)[1].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1] : '';
      }
      if (this.language === "2") {
        if ("2" in JSON.parse(this.detailsFrom.template)) {
          this.code = JSON.parse(this.detailsFrom.template)[2].match(
            /\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/
          )[1];
        } else {
          this.code = "";
        }
        //this.code = JSON.parse(this.detailsFrom.template)[2].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1] ? JSON.parse(this.detailsFrom.template)[2].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1] : '';
      }
      // if (this.language === '0') {
      //   this.code = JSON.parse(this.detailsFrom.template)[0].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1] ? JSON.parse(this.detailsFrom.template)[0].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1] : '';

      // }
      // if (this.language === '1') {
      //   this.code = JSON.parse(this.detailsFrom.template)[1].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1] ? JSON.parse(this.detailsFrom.template)[1].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1] : '';

      // }
      // if (this.language === '2') {
      //   this.code = JSON.parse(this.detailsFrom.template)[2].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1] ? JSON.parse(this.detailsFrom.template)[2].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1] : '';

      // }
    },
    getOjProblemInfoById() {
      getOjProblemInfoById({
        problem_id: this.problem_id,
      }).then((res) => {
        console.log(res, 111);
        this.test_case_id = res.ojProblemInfo.test_case_id;
        console.log(this.test_case_id, 123456);
        this.textInfo1 = JSON.parse(res.ojProblemInfo.test_case_score);
        if (this.$route.query.type1 != "game1") {
          this.languagesList = JSON.parse(res.ojProblemInfo.languages);
          this.languagesList.sort();
          if (this.$route.query.txt === undefined) {
            if (this.languagesList.includes("1")) {
              this.language = "1";
            } else {
              this.language = this.languagesList[0];
            }
          } else {
            this.language = this.$route.query.language;
          }
          this.languagesList.map((item) => {
            console.log(item, 12346);
            let obj = this.languages1.find(function (e) {
              return e.id === item;
            });
            console.log(obj, 1474411);
            this.arr1.push(obj);
          });
          console.log(this.arr1, 1474411);
          console.log(this.languagesList, 123456798);
        }
        this.detailsFrom = res.ojProblemInfo;
        console.log(res.ojProblemInfo.attachment_url, 565623);
        if (res.ojProblemInfo.attachment_url === null) {
          this.zipTxt = "";
        } else {
          this.zipTxt = res.ojProblemInfo.attachment_url
            .split("/")
            .slice(-1)[0]
            .split("-")
            .slice(-1)[0];
        }
        console.log(this.detailsFrom, 456562332);
        if (this.detailsFrom.description_show_type === 1) {
          this.$nextTick(() => {
            Prism.highlightAll();
            window.MathJax &&
              window.MathJax.Hub.Queue(
                [
                  "Typeset",
                  window.MathJax.Hub,
                  document.getElementsByClassName("mj"),
                ],
                function () {
                  //to do something   公式重新渲染完成后执行这个回调函数
                }
              );
          });
        }
        // Prism.highlightAll();
        // this.$nextTick(() => {
        //   window.MathJax && window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub, document.getElementsByClassName('mj')], function () {
        //     //to do something   公式重新渲染完成后执行这个回调函数
        //   });
        // })

        this.samples = JSON.parse(res.ojProblemInfo.samples);
        this.desc = this.samples[0].input;
        console.log(this.tableData, 222);
        if (
          sessionStorage.getItem("codeTxt") == "" ||
          sessionStorage.getItem("codeTxt") === null
        ) {
          if (this.tableData.length > 0) {
            this.code = this.tableData[0].code;
            this.language = this.tableData[0].language.toString();
            console.log(this.language, 112212);

            // this.tableData.map((item) => {
            //   console.log(item.code)
            //   this.code = item.code
            //   this.language = item.language.toString()
            // })
          } else {
            if (this.language === "0") {
              console.log(JSON.parse(this.detailsFrom.template)[0], 111);
              if ("0" in JSON.parse(this.detailsFrom.template)) {
                this.code = JSON.parse(this.detailsFrom.template)[0].match(
                  /\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/
                )[1];
              } else {
                this.code = "";
              }
              // this.code = JSON.parse(this.detailsFrom.template)[0].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1] ? JSON.parse(this.detailsFrom.template)[0].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1] : '';
            }

            if (this.language === "1") {
              if ("1" in JSON.parse(this.detailsFrom.template)) {
                this.code = JSON.parse(this.detailsFrom.template)[1].match(
                  /\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/
                )[1];
              } else {
                this.code = "";
              }
              // this.code = JSON.parse(this.detailsFrom.template)[1].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1] ? JSON.parse(this.detailsFrom.template)[1].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1] : '';
            }
            if (this.language === "2") {
              if ("2" in JSON.parse(this.detailsFrom.template)) {
                this.code = JSON.parse(this.detailsFrom.template)[2].match(
                  /\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/
                )[1];
              } else {
                this.code = "";
              }
              //this.code = JSON.parse(this.detailsFrom.template)[2].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1] ? JSON.parse(this.detailsFrom.template)[2].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1] : '';
            }
          }
        } else {
          this.code = sessionStorage.getItem("codeTxt");
        }
      });
    },
    DownloadFile() {
      console.log(this.detailsFrom.attachment_url, 1512121);

      window.open(this.detailsFrom.attachment_url, "_blank");
    },
    handleFullScreen1() {
      if (this.num2 === 16) {
        this.num = 0;
        this.num2 = 24;
      } else {
        this.num = 8;
        this.num2 = 16;
      }
    },
    // 全屏方法
    handleFullScreen() {
      if (this.num === 8) {
        this.num = 24;
        this.num2 = 0;
      } else {
        this.num = 8;
        this.num2 = 16;
      }
    },

    goback1() {
      this.$router.push({
        name: "matchDetails",
        query: {
          activeName: "second",
          id: this.$route.query.id,
          oj_contest_id: this.$route.query.oj_contest_id,
          isShow: this.$route.query.isShow,
          title: this.$route.query.title,
          type: "ganme",
          typeNext: this.$route.query.typeNext,
          languages: this.$route.query.languages,
          end_date: this.$route.query.end_date,
          rule_type: this.$route.query.rule_type,
          rule_type1: this.$route.query.rule_type1,
          typetime: this.$route.query.typetime,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.box1 {
  border: 1px solid #1fb26e;
  padding: 15px;
}

.questionBankDetails {
  height: 100%;
  width: 100%;

  .celebration {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 9999;
  }

  .celebration-effect {
    width: 200px;
    height: 200px;
    animation: bounce 1s infinite;
  }

  @keyframes bounce {
    0% {
      transform: translateY(0);
    }

    50% {
      transform: translateY(-20px);
    }

    100% {
      transform: translateY(0);
    }
  }
}

.topTitle {
  height: 60px;
  background: #fff;
  margin: 10px;

  padding: 20px;
  border-radius: 5px;
  box-sizing: border-box;
  font-size: 14px;

  span {
    color: rgba(0, 0, 0, 0.45);
  }
}

.main {
  height: calc(100vh - 150px);
  margin: 10px;
  border-radius: 5px;
  box-sizing: border-box;
  overflow: hidden;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.clearfix:after {
  content: "";
  display: block;
  visibility: hidden;
  clear: both;
}

.main_top ul {
  width: 100%;
  border-bottom: 1px solid #ebeef5;
  padding-bottom: 10px;
}

.main_top {
  text-align: center;
}

.main_top li {
  float: left;
}

.txt1 {
  color: #909399;
  font-size: 14px;
  font-weight: bold;
}

.txt2 {
  color: rgba(166, 166, 166, 1);
  font-size: 14px;
}

.main-left {
  height: 100%;
  background: #fff;
  padding: 20px;
  height: calc(100vh - 150px);
  box-sizing: border-box;
  overflow-y: auto;
}

.main_cotton div {
  margin-top: 20px;
}

.txt3 {
  font-size: 16px;
  font-weight: bold;
}

.txt4 {
  font-size: 16px;
  font-weight: bold;
  color: #6c91f2;
}

.main-right {
  background: #fff;

  padding-top: 0px;
  padding-right: 0px;
  padding-left: 0px;

  height: calc(100vh - 150px);
  box-sizing: border-box;
  overflow-y: hidden;
}

.editor {
  // height: 90% !important;
}

.main_top ::v-deep .el-icon-monitor:before {
  color: #000;
}

.sample-input {
  width: 45%;
  margin-right: 5%;
}

.main_msg /deep/ .el-alert {
  padding: 5px 16px;
  margin-left: 20px;
}

.main_msg /deep/ .el-alert__closebtn {
  top: 9px;
  right: 8px;
}

/deep/ .main_cotton img {
  max-width: 100%;
}

/deep/.main_cotton ul {
  list-style: auto;
  list-style-type: initial;
  margin-left: 20px;
}

/deep/.main_cotton ol {
  list-style: auto;
  list-style-type: decimal;
  margin: auto;
  padding: auto;
  margin-left: 20px;
}

.liListStyle:nth-of-type(2n) {
  margin-left: 10px;
}

.Console {
}

// /deep/ .CodeMirror {
//   height: calc(100vh - 230px) !important;
// }
// .CodeMirror1 {
//   height: calc(100vh - 500px) !important;
// }
/deep/ .vue-codemirror {
  height: 100%;
}

/deep/ .cm-s-monokai.CodeMirror {
  height: 98% !important;
}

/deep/ .weeor .el-alert__content {
  padding: 0px;
}

/deep/ .weeor .el-icon-close:before {
  content: "";
}

/deep/ #pane-second1 {
  height: 117px;
  overflow-y: auto;
}

/deep/ .el-tabs--border-card {
  box-shadow: none;
}

/deep/.el-drawer__body {
  overflow: hidden !important;
}

/deep/.hljs {
  padding: 20px !important;
  margin-top: 10px !important;
  margin-bottom: 10px !important;
  border-radius: 5px !important;
}

/deep/.el-dialog {
  border-radius: 10px !important;
}

/deep/ .v-note-wrapper {
  border: 0px;
}

/deep/ .v-note-wrapper .v-note-panel .v-note-show .v-show-content,
.v-note-wrapper .v-note-panel .v-note-show .v-show-content-html {
  padding: 0;
}

/deep/ .codeStyle .CodeMirror-scroll {
  min-height: auto;
  max-height: none;
}

.v-note-wrapper {
  display: block !important;
  position: static !important;
}
</style>
